import { Product } from '../../products/storage'
import { CartItem } from '../storage/cart.types'

export const isCartItem = (item: CartItem | Product): item is CartItem => {
  return !!item
}
